/* eslint-disable indent */
// Libraries
import React, { useState, useEffect } from 'react';
import { useTable } from 'react-table';
import PropTypes from 'prop-types';

const StringBaseEvent = ({ item }) => {
    return (
        <div className="form-field">
            <p className="label">{item.label}</p>
            <p className="label-value">{String(item.value)}</p>
        </div>
    );
};

const ArrayBaseEvent = ({ item }) => {
    return (
        <div className="form-field">
            <p className="label">{item.label}</p>
            <p className="label-value">{item.value.join(', ')}</p>
        </div>
    );
};

const flatMapPermission = values => {
    const allPermission = values.map(item => item.permissionName);
    if (allPermission && allPermission.length) {
        return allPermission.join(', ');
    }
    return '-';
};

const formatCell = value => {
    if (typeof value === 'object' && value !== null) {
        const formattedValue = Object.keys(value);
        return formattedValue.map(item => {
            return `${item}:${value[item]} `;
        });
    }
    return String(value);
};

const TableBaseEvent = ({ item }) => {
    const data = React.useMemo(() => {
        const formattedData =
            item &&
            item.value.map(item => {
                const keys = Object.keys(item);
                const formatColum = {};
                keys.forEach(value => {
                    if (value === 'permissionDetail') {
                        formatColum[value] = flatMapPermission(item[value]);
                    } else {
                        formatColum[value] = formatCell(item[value]);
                    }
                });
                return formatColum;
            });
        return formattedData;
    }, [item]);

    const columns = React.useMemo(() => {
        const keys =
            item.value && item.value.length ? Object.keys(item.value[0]) : [];
        const columns = keys.map(value => {
            return {
                Header: String(value),
                accessor: String(value),
            };
        });
        return columns;
    }, [item]);
    const tableInstance = useTable({ columns, data });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance;

    return (
        <div className="form-field table-field">
            <p className="label">{item.label}</p>
            <div className="table-wrap">
                <table {...getTableProps()}>
                    <thead>
                        {/* // Loop over the header rows */}
                        {headerGroups.map(headerGroup => (
                            // Apply the header row props
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {/* // Loop over the headers in each row */}
                                {headerGroup.headers.map(column => (
                                    // Apply the header cell props
                                    <th {...column.getHeaderProps()}>
                                        {/* Render the header */}
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    {/* Apply the table body props */}
                    <tbody {...getTableBodyProps()}>
                        {/* Loop over the table rows */}
                        {rows.map((row, index) => {
                            // Prepare the row for display
                            prepareRow(row);
                            return (
                                // Apply the row props
                                <tr {...row.getRowProps()} key={index}>
                                    {/* // Loop over the rows cells */}
                                    {row.cells.map(cell => {
                                        // Apply the cell props
                                        return (
                                            <td {...cell.getCellProps()}>
                                                {/* Render the cell contents */}
                                                {cell.render('Cell')}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const EventData = ({ data }) => {
    return (
        <>
            <h2 className="form-title">Event Data</h2>
            <div className="form-section viewOnly event-list-wrap">
                {data.map(item => {
                    if (item.type === 'array') {
                        return <ArrayBaseEvent item={item} />;
                    }
                    if (item.type === 'table') {
                        return <TableBaseEvent item={item} />;
                    }
                    return <StringBaseEvent item={item} />;
                })}
            </div>
        </>
    );
};

EventData.propTypes = {
    data: PropTypes.object,
};

StringBaseEvent.propTypes = {
    item: PropTypes.array,
};

ArrayBaseEvent.propTypes = {
    item: PropTypes.array,
};

TableBaseEvent.propTypes = {
    item: PropTypes.array,
};

export default EventData;
